import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=daa4d210&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=daa4d210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa4d210",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('daa4d210')) {
      api.createRecord('daa4d210', component.options)
    } else {
      api.reload('daa4d210', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=daa4d210&scoped=true&", function () {
      api.rerender('daa4d210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2s2vMko5176rw/JS/comp/PopupBox.vue"
export default component.exports